let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("1vxKp")).then(() => parcelRequire('3rtLT'));